define.alias("shared/utils/string-formatters/camel-to-snake", "settings/utils/string-formatters/camel-to-snake");